import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GalleryFile } from '../../services';
import { MediaType } from './thumbnailSlice';

export interface FetchGalleryPayload {
  nextPageToken: string | null;
}

export interface GalleryItem {
  name: string;
  fullPath: string;
  contentType?: string;
  mediaType?: MediaType;
  thumbnailUrl?: string | null;
  downloadUrl?: string;
}

interface GalleryState {
  loading: boolean;
  error: string | null;
  nextPageToken: string | null;
  items: GalleryItem[];
  fetched: boolean;
}

const initialState: GalleryState = {
  loading: false,
  error: null,
  nextPageToken: null,
  items: [],
  fetched: false
};

export const gallerySlice = createSlice({
  name: 'gallery',
  initialState,
  reducers: {
    fetchGallery: (state) => {
      state.loading = true;
      state.error = null;},
    fetchGallerySuccess: (state, action: PayloadAction<FetchGalleryPayload>) => {
      const { nextPageToken } = action.payload;
      state.loading = false;
      state.error = null;
      state.nextPageToken = nextPageToken;
      state.fetched = true;
    },
    fetchGalleryItems: (state) => {
      return state;
    },
    appendGalleryItems: (state, action: PayloadAction<GalleryFile[]>) => {
      const items: GalleryItem[] = action.payload.map(file => ({
        name: file.name,
        fullPath: file.fullPath,
        contentType: file.contentType,
        downloadUrl: file.downloadUrl,
      }));

      state.items = [...state.items, ...items];
    },
    fetchGalleryFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchGallery,
  fetchGallerySuccess,
  fetchGalleryFailure,
  appendGalleryItems,
} = gallerySlice.actions;

export default gallerySlice.reducer;
